<div
  (mouseenter)="activateAvatarMenu()"
  (mouseleave)="deactivateAvatarMenu()">
  <div class="navbar-avatar flex flex-row justify-center items-center">
    <app-avatar-icon data-qa="nav-avatar-icon" class="thumbnail"/>
    <app-all-icons data-qa="nav-avatar-arrow-down" [iconNameAndStyling]="'arrow-down.svg;icon-size-1p25'"/>
  </div>
  @if (showAvatarMenu) {
    <div
      @fadeInOut
      class="menu-wrapper flex flex-col content-center items-center">
      <div class="whitespace-0p5"></div>
      <div class="avatar-menu flex flex-col content-center items-stretch">
        <span
          data-qa="account-settings"
          class="flex items-center gap-[0.5rem]"
          (click)="navigateWithCheck(FRONT_URLS.CABINET)">
          <app-all-icons [iconNameAndStyling]="'user-icon-empty.svg;icon-size-1p25'"/>
          Account settings
        </span>
        <span
          data-qa="org-settings-menu-item"
          class="flex items-center gap-[0.5rem]"
          (click)="navigateWithCheck(FRONT_URLS.ORG_SETTINGS)">
          <app-all-icons [iconNameAndStyling]="'organization-settings.svg;icon-size-1p25'"/>
          {{ isOrgAdmin ? 'Organization settings' : 'Organization'}}
        </span>
        <span
          data-qa="support"
          class="flex items-center gap-[0.5rem]"
          (click)="mailToSupport()">
          <app-all-icons [iconNameAndStyling]="'sms-logo.svg;icon-size-1p25'"/>
          Support
        </span>
        <span
          data-qa="header-user-menu-logout"
          class="flex items-center gap-[0.5rem] red-10"
          (click)="logout()">
          <app-all-icons [iconNameAndStyling]="'exit.svg;icon-size-1p25'"/>
          Log out
        </span>
      </div>
    </div>
  }
</div>

@if (showExpiredSessionModal) {
  <app-modal-expired-session
    (goToLoginEmitter)="goToLogin()"
  />
}
